import { CustomButtonEvent } from "./types/CustomButtonEvent";
import { CustomLinkEvent } from "./types/CustomLinkEvent";
import { DataLayerConfig } from "./types/DataLayerConfig";
declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

export const gtmCustomButtonEvent = (
  eventName: CustomButtonEvent,
  buttonText: string,
  dataLayerConfig?: DataLayerConfig
) => {
    window.dataLayer.push({
      event: eventName,
      button_location: dataLayerConfig?.location,
      button_text: buttonText,
      page_title: document.title,
      product_category: dataLayerConfig?.productCategory,
      product_name: dataLayerConfig?.productName,
      product_value: dataLayerConfig?.productValue,
      currency: "GBP",
    });
};

export const gtmCustomLinkEvent = (
  eventName: CustomLinkEvent,
  dataLayerConfig?: DataLayerConfig
) => {
    window.dataLayer.push({
      event: eventName,
      event_location: dataLayerConfig?.location,
      page_title: document.title,
      product_category: dataLayerConfig?.productCategory,
      product_name: dataLayerConfig?.productName,
      product_value: dataLayerConfig?.productValue,
      currency: "GBP",
    });
};
